"use client";

import React from "react";
import { Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ATaleOfFlavors() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll();
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="30023" id="the-art-of-nordic-flavor" className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden dark bg-background">
      {}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        @keyframes leaf-sway {
          0% { transform: translateY(0) rotate(0deg) translateX(0); opacity: 0; }
          20% { opacity: 1; }
          50% { transform: translateY(15px) rotate(10deg) translateX(5px); }
          80% { opacity: 1; }
          100% { transform: translateY(30px) rotate(-5deg) translateX(0); opacity: 0; }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-leaf-fall {
          animation: leaf-sway 4s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-transparent to-black/90 z-10" />
        <div className="w-full h-full bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/nordic_plating_macro.png)]" aria-hidden="true" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          
          {}
          <div ref={titleRef} className={`transition-all duration-1000 ${isTitleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-6xl md:text-7xl lg:text-9xl font-serif font-light text-foreground tracking-tighter animate-float italic">The Art of Nordic Flavor</h1>
          </div>

          {}
          <div ref={contentRef} className={`transition-all duration-1000 delay-300 ${isContentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="backdrop-blur-xl bg-card/20 border border-white/10 p-8 rounded-sm shadow-2xl max-w-2xl mx-auto">
              <p className="text-lg md:text-xl text-muted-foreground font-sans font-light leading-relaxed mb-8 tracking-wide">
                A journey through the raw landscapes of Denmark, distilled into avant-garde plates. 
                Experience the minimalist elegance and seasonal purity of New Nordic gastronomy.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Button asChild size="lg" className="rounded-none px-10 py-7 text-sm font-mono uppercase tracking-widest bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-500">
                  <Link to="/TheMenuPage">
                    The Menu
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="rounded-none px-10 py-7 text-sm font-mono uppercase tracking-widest bg-transparent hover:bg-white/10 border-white/20 text-foreground transition-all duration-500">
                  <Link to="/TheKitchenPage">
                    The Kitchen
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 pointer-events-none">
        <span className="text-xs font-mono font-medium text-muted-foreground uppercase tracking-[0.3em] text-[10px]">Discover</span>
        <div className="text-primary/60 animate-leaf-fall">
          <Leaf size={20} className="fill-primary/10" />
        </div>
      </div>
    </section>;
}